import React from 'react';
import ContentEditable from 'react-contenteditable';
import styled from 'styled-components';

import { NO_ACTION } from 'craft/constants';

const Editable = styled<any>(ContentEditable)`
  outline: none;
  // keep space when editing even when all text has been deleted
  display: inline-block;
  min-width: 2px;

  &:hover {
    cursor: ${({ disabled }: any) => (disabled ? 'default' : 'text')};
  }
`;

const TextEditable = React.forwardRef((props: any, ref) => {
  return <Editable {...props} innerRef={ref} data-focus-listener={NO_ACTION} />;
});

export default TextEditable;
